var map = {
	"./en-us.json": 307,
	"./pt-br.json": 308
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 306;


//////////////////
// WEBPACK FOOTER
// ./src/language-pack ^\.\/.*\.json$
// module id = 306
// module chunks = 0